import { useEffect, useState } from "react";
import { Trash2, ExternalLink, FileDown, Search, Plus } from "lucide-react";
import client, { API } from "@/lib/api";
import { SectionHeader, EmptyState, notifyError } from "./_ui";
import ActCreateDialog from "./ActCreateDialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export default function Acts() {
  const [acts, setActs] = useState([]);
  const [q, setQ] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const load = (query = "") =>
    client.get("/admin/acts", { params: { q: query } }).then((r) => setActs(r.data)).catch(notifyError);
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Удалить акт?")) return;
    await client.delete(`/admin/acts/${id}`);
    load(q);
  };

  return (
    <div>
      <SectionHeader
        title="Акты"
        description="Все выпущенные акты осмотра."
        action={
          <Button data-testid="act-create-open-btn" onClick={() => setCreateOpen(true)} className="rounded-lg font-medium" style={{ background: "var(--ci-accent)", color: "#1a1a1a" }}>
            <Plus className="w-4 h-4 mr-1.5" /> Создать акт вручную
          </Button>
        }
      />
      <div className="relative mb-4 max-w-sm">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
        <Input
          data-testid="acts-search"
          value={q}
          onChange={(e) => { setQ(e.target.value); load(e.target.value); }}
          placeholder="Поиск по VIN или номеру"
          className="pl-9 border-neutral-300"
        />
      </div>

      {acts.length === 0 ? (
        <EmptyState text="Актов пока нет. Создайте акт вручную или через Telegram-бот." />
      ) : (
        <div className="border border-neutral-200 rounded-lg bg-white overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Номер</TableHead>
                <TableHead>Марка</TableHead>
                <TableHead>VIN</TableHead>
                <TableHead>Дата осмотра</TableHead>
                <TableHead>Статус</TableHead>
                <TableHead className="text-right">Действия</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {acts.map((a) => (
                <TableRow key={a.id} data-testid={`act-row-${a.id}`}>
                  <TableCell className="font-medium">{a.act_number}</TableCell>
                  <TableCell>{a.brand_name}</TableCell>
                  <TableCell className="font-mono text-xs">{a.vin}</TableCell>
                  <TableCell>{a.inspection_date}</TableCell>
                  <TableCell>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-neutral-100">{a.status}</span>
                  </TableCell>
                  <TableCell className="text-right whitespace-nowrap">
                    <a href={`/act/${a.token}`} target="_blank" rel="noreferrer" className="inline-flex p-1.5 text-neutral-600 hover:text-black" data-testid={`act-view-${a.id}`}>
                      <ExternalLink className="w-4 h-4" />
                    </a>
                    <a href={`${API}/act/${a.token}/pdf`} target="_blank" rel="noreferrer" className="inline-flex p-1.5 text-neutral-600 hover:text-black" data-testid={`act-pdf-${a.id}`} title="Скачать PDF">
                      <FileDown className="w-4 h-4" />
                    </a>
                    {a.lang && a.lang !== "ru" && (
                      <a href={`${API}/act/${a.token}/pdf?lang=ru`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-0.5 p-1.5 text-neutral-600 hover:text-black" data-testid={`act-pdf-ru-${a.id}`} title="Скачать PDF (копия на русском)">
                        <FileDown className="w-4 h-4" /><span className="text-[10px] font-medium">RU</span>
                      </a>
                    )}
                    <button onClick={() => remove(a.id)} className="inline-flex p-1.5 text-red-600 hover:text-red-700" data-testid={`act-delete-${a.id}`}>
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      <ActCreateDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={() => load(q)} />
    </div>
  );
}
